import { FC } from 'react'
import { Icon } from '@chakra-ui/react'
import { FiChevronDown, FiDownload, FiFileText, FiList, FiUser, FiUserCheck } from 'react-icons/fi'
import { IconType } from 'react-icons'
import { IconBox } from '../../../common/components/IconBox'
import { ExportIconVariant } from '../types'

export const DownloadIcon: FC<{ size?: number }> = ({ size = 13 }) => (
  <Icon as={FiDownload} boxSize={`${size}px`} aria-hidden />
)

export const ChevronDownIcon: FC = () => (
  <Icon as={FiChevronDown} boxSize="10px" color="gray.400" aria-hidden />
)

const iconColors: Record<ExportIconVariant, string> = {
  blue: '#3182CE',
  green: '#38A169',
  purple: '#805AD5',
  amber: '#D97706',
}

const iconBackgrounds: Record<ExportIconVariant, string> = {
  blue: 'blue.50',
  green: 'green.50',
  purple: 'purple.50',
  amber: 'orange.50',
}

const rowIcons: Record<ExportIconVariant, IconType> = {
  blue: FiUser,
  green: FiUserCheck,
  purple: FiFileText,
  amber: FiList,
}

export const ExportRowIcon: FC<{ variant: ExportIconVariant }> = ({ variant }) => (
  <IconBox boxSize={36} iconSize={18} bg={iconBackgrounds[variant]}>
    <Icon as={rowIcons[variant]} boxSize="18px" color={iconColors[variant]} aria-hidden />
  </IconBox>
)
